import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { getStorage } from "../storageHelper";
import { customerInfoIdValue, googleTagMgrId } from "../helperConstants";

/** Initializes GTM exactly once, on mount. */
export const useGoogleTagManagerInit = (): void => {
  useEffect(() => {
    const infoId = getStorage(customerInfoIdValue);
    TagManager.initialize({
      gtmId: googleTagMgrId,
      dataLayer: { userId: infoId ?? "0" },
    });
    // Intentionally run once — GTM should only be bootstrapped a single time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

/** Pushes a page/stage-change event onto the dataLayer. Call from effects that track navigation. */
export const pushUserUpdateEvent = (): void => {
  const infoId = getStorage(customerInfoIdValue);
  const win = window as typeof window & { dataLayer?: unknown[] };
  win.dataLayer = win.dataLayer || [];
  win.dataLayer.push({ event: "user_update", userId: infoId ?? "0" });
};
